import React from 'react';

const Image = ({ src, ...rest }) => {
  return <img src={src} alt={rest.alt} {...rest} />;
};

export default Image;
